export type ErrorWithMessage = {
  message: string;
};

export const isObjectWithMessage = (error: unknown): error is ErrorWithMessage =>
  typeof error === 'object' && error !== null && 'message' in error;
